import dashboardReducer from "./dashboard/const";
import dashboardStatsReducer from "./dashboard/stats"

import scopeLevelReducer from "./scopeLevel/const";

import mspUserManagementReducer from "./userManagement/msp/const";
import orgUserManagementReducer from "./userManagement/org/const";
import onPremUserManagemantRuducer from "./userManagement/on-prem/const";

import profile from "./profile/const";

import meReducer from "./me/const";

import topologyReducer from "./topology/const";

import devicesReducer from "./devices/const";
import devicesDrawerContentReducer from "./devices/drawerContent/const";
import firmwareManagementsReducer from "./firmwareManagements/const";
import addDeviceInformHostReducer from "./devices/addDevice/informHost";
import addDeviceSitesReducer from "./devices/addDevice/sites";
import addDeviceInventoryDeviceAccountReducer from "./devices/addDevice/inventoryDeviceAccount";
import addDeviceDeviceAccountReducer from "./devices/addDevice/deviceAccounts";
import addDeviceOrgDevicesReducer from "./devices/addDevice/orgDevices";
import addDeviceSiteDevicesReducer from "./devices/addDevice/siteDevices";
import addDeviceDiscoveredOrgDevicesReducer from "./devices/addDevice/discoveredOrgDevices";
import addDeviceDiscoveredSiteDevicesReducer from "./devices/addDevice/discoveredSiteDevices";
import addDeviceStopDiscoveryOrgDevices from "./devices/addDevice/stopDiscoveryOrgDevices";
import addDeviceStopDiscoverySiteDevices from "./devices/addDevice/stopDiscoverySiteDevices";
import addDeviceAuthenticatedOrgDevices from "./devices/addDevice/authenticatedOrgDevices";
import addDeviceAuthenticatedSiteDevices from "./devices/addDevice/authenticatedSiteDevices";
import addDeviceIpSettingOrgDevices from "./devices/addDevice/ipSettingOrgDevices";
import addDeviceIpSettingSiteDevices from "./devices/addDevice/ipSettingSiteDevices";
import addDeviceAdoptOrgDevices from "./devices/addDevice/adoptOrgDevices";
import addDeviceAdoptSiteDevices from "./devices/addDevice/adoptSiteDevices";
import addDevicePreRegisterOrgDevices from "./devices/addDevice/preRegisterDevices";

import eventsReducer from "./events/const";

import clientsReducer from "./clients/const";
import selectedClientReducer from "./clients/selectedClient";
import clientStatisticsSlice from "./clients/statistics";
import wirelessSSIDReducer from "./wireless/ssid";
import wirelessRadioReducer from "./wireless/radio";
import wiredRuducer from "./wired/const";
import portTagsReducer from "./wired/portTags";
import wiredConfigProvisionings from "./wired/configProvisionings";
import defaultConfigProvisionings from "./wired/defaultConfigProvisionings";
import captivePortalReducer from "./captivePortal/const";
import profilesPortsReducer from "./profiles/ports/const";
import profilesMacAddressReducer from "./profiles/macAddress/const";
import profilesRadiusServerReducer from "./profiles/radiusServer/const";
import settingNotificationsReducer from "./settingNotifications/const";
import mspGeneralReducer from "./settingsGeneral/msp/const";
import orgGeneralReducer from "./settingsGeneral/org/const";
import siteGeneralReducer from "./settingsGeneral/site/const";
import deviceModelList from "./system/deviceModelList";

import ainsightOverviewReducer from "./ainsight/overview/const";
import ainsightServiceExperienceReducer from "./ainsight/serviceExperience/const";
import ainsightOperationsReducer from "./ainsight/operations/const";
import ainsightRoamReducer from './ainsight/roam/const';
import ainsightWirelessCoverageReducer from './ainsight/wirelessCoverage/const';
import ainsightLinkIntegrityReducer from './ainsight/linkIntegrity/const';
import licenseReducer from "./license/const";

const bogusReducers = {
  dashboard: dashboardReducer,
  dashboardStats: dashboardStatsReducer,
  scopeLevel: scopeLevelReducer,
  mspUserManagement: mspUserManagementReducer,
  orgUserManagement: orgUserManagementReducer,
  onPremUserManagement: onPremUserManagemantRuducer,
  profile: profile,
  me: meReducer,
  topology: topologyReducer,
  devices: devicesReducer,
  devicesDrawerContent: devicesDrawerContentReducer,
  firmwareManagements: firmwareManagementsReducer,
  addDeviceInformHost: addDeviceInformHostReducer,
  addDeviceSites: addDeviceSitesReducer,
  addDeviceInventoryDeviceAccount: addDeviceInventoryDeviceAccountReducer,
  addDeviceDeviceAccount: addDeviceDeviceAccountReducer,
  addDeviceOrgDevices: addDeviceOrgDevicesReducer,
  addDeviceSiteDevices: addDeviceSiteDevicesReducer,
  addDeviceDiscoveredOrgDevices: addDeviceDiscoveredOrgDevicesReducer,
  addDeviceDiscoveredSiteDevices: addDeviceDiscoveredSiteDevicesReducer,
  addDeviceStopDiscoveryOrgDevices: addDeviceStopDiscoveryOrgDevices,
  addDeviceStopDiscoverySiteDevices: addDeviceStopDiscoverySiteDevices,
  addDeviceAuthenticatedOrgDevices: addDeviceAuthenticatedOrgDevices,
  addDeviceAuthenticatedSiteDevices: addDeviceAuthenticatedSiteDevices,
  addDeviceIpSettingOrgDevices: addDeviceIpSettingOrgDevices,
  addDeviceIpSettingSiteDevices: addDeviceIpSettingSiteDevices,
  addDeviceAdoptOrgDevices: addDeviceAdoptOrgDevices,
  addDeviceAdoptSiteDevices: addDeviceAdoptSiteDevices,
  addDevicePreRegisterOrgDevices: addDevicePreRegisterOrgDevices,
  events: eventsReducer,
  clients: clientsReducer,
  selectedClient: selectedClientReducer,
  clientStatistics: clientStatisticsSlice,
  wiredConfigProvisionings: wiredConfigProvisionings,
  defaultConfigProvisionings: defaultConfigProvisionings,
  wireless: wirelessSSIDReducer,
  wirelessRadio: wirelessRadioReducer,
  wired: wiredRuducer,
  portTags: portTagsReducer,
  captivePortal: captivePortalReducer,
  profilesPorts: profilesPortsReducer,
  profilesMacAddress: profilesMacAddressReducer,
  profilesRadiusServer: profilesRadiusServerReducer,
  settingNotifications: settingNotificationsReducer,
  mspGeneral: mspGeneralReducer,
  orgGeneral: orgGeneralReducer,
  siteGeneral: siteGeneralReducer,
  deviceModelList: deviceModelList,
  ainsightOverview: ainsightOverviewReducer,
  ainsightServiceExperience: ainsightServiceExperienceReducer,
  ainsightOperations: ainsightOperationsReducer,
  ainsightRoam: ainsightRoamReducer,
  ainsightWirelessCoverage: ainsightWirelessCoverageReducer,
  ainsightLinkIntegrity: ainsightLinkIntegrityReducer,
  license: licenseReducer,
};

export default bogusReducers;
